import { useEffect, useState } from 'react';
import { SDKContext } from './context';
import { useSDKInitialization, useOAuthLogin } from './hooks';

export const SDKProvider = ({ children }) => {
  const [sdkReady, setSdkReady] = useState(false);
  const [sdkError, setSdkError] = useState(null);
  const [initializingSDK, setInitializingSDK] = useState(false);

  // Get SDK initialization hooks
  const {
    handleSdkStatusChange,
    handleAuthenticationStateChange,
    loadSDKWithHandlers
  } = useSDKInitialization(setSdkReady, setSdkError, setInitializingSDK);

  // Get OAuth login hook
  const handleOAuthLogin = useOAuthLogin();

  // Load SDK on mount
  useEffect(() => {
    const loadAndInitialize = async () => {
      await loadSDKWithHandlers();
    };
    loadAndInitialize();
    
    // Cleanup event listeners on unmount
    return () => {
      try {
        if (window.nbc?.identity?.off) {
          window.nbc.identity.off('status', handleSdkStatusChange);
          window.nbc.identity.off('authenticationState', handleAuthenticationStateChange);
        }
      } catch (error) {
        console.warn('[SDKProvider] Cleanup error:', error);
      }
    };
  }, [handleSdkStatusChange, handleAuthenticationStateChange, loadSDKWithHandlers]);

  // Expose SDK methods and state
  const value = {
    sdkReady,
    sdkError,
    initializingSDK,
    identity: window.nbc?.identity,
    handleOAuthLogin
  };

  return (
    <SDKContext.Provider value={value}>
      {children}
    </SDKContext.Provider>
  );
};
